const languageCodes = [
  'af',
  'sq',
  'am',
  'ar',
  'an',
  'hy',
  'ast',
  'az',
  'eu',
  'be',
  'bn',
  'bs',
  'br',
  'bg',
  'ca',
  'ckb',
  'zh',
  'co',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'eo',
  'et',
  'fo',
  'fil',
  'fi',
  'fr',
  'gl',
  'ka',
  'de',
  'el',
  'gn',
  'gu',
  'ha',
  'haw',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'ia',
  'ga',
  'it',
  'ja',
  'kn',
  'kk',
  'km',
  'ko',
  'ku',
  'ky',
  'lo',
  'la',
  'lv',
  'ln',
  'lt',
  'mk',
  'ms',
  'ml',
  'mt',
  'mr',
  'mn',
  'ne',
  'no',
  'nb',
  'nn',
  'oc',
  'or',
  'om',
  'ps',
  'fa',
  'pl',
  'pt',
  'pa',
  'qu',
  'ro',
  'mo',
  'rm',
  'ru',
  'gd',
  'sr',
  'sh',
  'sn',
  'sd',
  'si',
  'sk',
  'sl',
  'so',
  'st',
  'es',
  'su',
  'sw',
  'sv',
  'tg',
  'ta',
  'tt',
  'te',
  'th',
  'ti',
  'to',
  'tr',
  'tk',
  'tw',
  'uk',
  'ur',
  'ug',
  'uz',
  'vi',
  'wa',
  'cy',
  'fy',
  'xh',
  'yi',
  'yo',
  'zu',
];

const getLanguageName = (code, locale) => {
  try {
    return new Intl.DisplayNames([locale], { type: 'language' }).of(code);
  } catch {
    return undefined;
  }
};

const getLanguageLabel = (code, locale) => {
  const localizedName = getLanguageName(code, locale);
  const nativeName = getLanguageName(code, code);

  if (!localizedName) {
    return code;
  }

  if (!nativeName || nativeName === localizedName) {
    return localizedName;
  }

  return `${localizedName} - ${nativeName}`;
};

export const getLanguageList = (locale = 'en') =>
  languageCodes.map((code) => ({
    name: getLanguageLabel(code, locale),
    code,
  }));

export default getLanguageList();
